/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { DesktopHeader } from '../../DesktopHeader/DesktopHeader';

export namespace DocumentViewerPageHeader {
  export interface Props {}
}

export const DocumentViewerPageHeader: React.FC<DocumentViewerPageHeader.Props> = () => {
  const headerLinks = [
    {
      display: 'Exit',
      handleClick() {
        window.close();
      },
    },
  ];

  return <DesktopHeader data-it="NotaryHeader" headerLinks={headerLinks} />;
};
